import axios from "axios";

export const getTypes = async () => {
    const response = await axios.get("api/tasktypes");
    const types = response.data;
    return types;
}